import {
  REQUEST_PRINT,
  RECEIVE_PRINT,
  ADD_TO_PRINTQUEUE,
  REMOVE_FROM_PRINTQUEUE,
  CLEAR_PRINTQUEUE
} from './actions';

const localStorage = require('web-storage')().localStorage;

export function print(state = {
  isFetching: false,
  didInvalidate: false,
  selection: [],
  response: null
}, action) {
  switch (action.type) {
    case REQUEST_PRINT:
      return Object.assign({}, state, {
        isFetching: true,
        selection: action.selection,
        didInvalidate: false
      });
    case RECEIVE_PRINT:
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
        response: action.response,
        lastUpdated: action.receivedAt
      });
    default:
      return state;
  }
}

export function printQueue(state = {
  items: []
}, action) {
  let items;
  try {
    items = JSON.parse(localStorage.get('react__dia__printqueue'));
  } catch (e) {
    items = state.items;
  }
  if (!items) {
    items = [];
  }
  let result = state;
  result.items = items;
  switch (action.type) {
    case ADD_TO_PRINTQUEUE:
      result = Object.assign({}, state, {
        items: [...items, action.item]
      });
      break;
    case REMOVE_FROM_PRINTQUEUE:
      result = Object.assign({}, state, {
        items: items.filter(item => item.id !== action.id)
      });
      break;
    case CLEAR_PRINTQUEUE:
      result = Object.assign({}, state, {
        items: []
      });
      break;
  }
  localStorage.set('react__dia__printqueue', JSON.stringify(result.items));
  return result;
}



/** WEBPACK FOOTER **
 ** ./src/modules/print/reducer.js
 **/